module.exports = __webpack_public_path__ + "img/goldregen-2020-051.5046447a.jpg";